export default "__VITE_ASSET__Z6O8$2$1__"